import React from 'react'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import { CMSState, Link } from '../../../../cms/blocks/types.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../public_site.main.mod'
import { link } from '../../../../cms/blocks/utils.gen'
import { decodeHTMLEntities } from '../../../../../helpers'
import { WordPress } from '../../../../wordpress/wordpress_api'
import { getImageSize } from '../../../utils/extra_images.mod'
import Lottie from 'react-lottie';

export interface gridWithImageBlockProps {
  title: string
  intro: string
  show_primary: boolean
  primary_button: Link
  items: gridWithImageItemProps[]

  show_in_page_navigation: boolean
  navigation_title: string
}

export interface gridWithImageItemProps {
  title: string
  intro: string
  label: string
  image: WordPress.Image
  has_link: boolean
  link: Link
  isAnimation: boolean
  animation_data: string
}

export type gridWithImageBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
}>

export function gridWWithImageBlock<customBlockData, extra_images>(
  props: gridWithImageBlockProps,
  options?: { style: gridWithImageBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: _ => (
        <section
          id={props.navigation_title}
          className="block block--grid block--grid-plain">

          <div className="block__inner container container--l grid--block">
            <header className="block__header block__header--icon">
              <div className="block__header-inner">
                {props.title && <h2 className="block__title typo--l">{decodeHTMLEntities(props.title)}</h2>}
                {props.intro && <div className="block__intro text--styled" dangerouslySetInnerHTML={{ __html: props.intro }}></div>}
              </div>
              {props.show_primary && (
                <footer className="block__footer">
                  {link(props.primary_button, { classname: "btn btn--tertiary" }, props.primary_button.title)}
                </footer>
              )}
            </header>

            <div className="block__content">
              <ul className="block__grid grid c--columns">
                {props.items.map((l, index) => (
                  <li className="grid__item item" key={index}>
                    <article className="grid__article">
                      {l.title && l.has_link == true
                        ? link(
                          l.link,
                          {
                            classname: "grid__inner grid__link grid__link--image",
                          },
                          <>
                            <div className={`grid__content grid__content--image`}>
                              <header className="grid__header">
                                <h3 className="grid__title typo--m">{l.title}</h3>
                                {l.intro &&
                                  <p className="grid__intro">{l.intro}</p>
                                }
                              </header>
                              <svg
                                className={`grid__icon`}
                                width="25px"
                                height="14px"
                                aria-hidden="true"
                              >
                                <use xlinkHref="#icon--arrow" />
                              </svg>
                            </div>
                            <div className="grid__visual">
                              {l.animation_data != undefined && l.isAnimation ?
                                <Lottie
                                  options={{
                                    loop: true,
                                    path: l.animation_data,
                                  }}
                                />
                                :
                                <img className="grid__image"
                                  src={getImageSize(l.image, '1320w')}
                                  key={l.image.id}
                                  width="1320"
                                  height="765"
                                  alt={l.image.alt_text}
                                />}
                            </div>
                          </>
                        )
                        :
                        <div className="grid__inner">
                          <div className={`grid__content grid__content--image`}>
                            <header className="grid__header">
                              <h3 className="grid__title typo--m">{l.title}</h3>
                              {l.intro &&
                                <p className="grid__intro">{l.intro}</p>
                              }
                            </header>
                          </div>
                          <div className="grid__visual">
                            {l.animation_data != undefined && l.isAnimation ?
                              <Lottie
                                options={{
                                  loop: true,
                                  path: l.animation_data,
                                }}
                              />
                              :
                              <img className="grid__image"
                                src={getImageSize(l.image, '1320w')}
                                key={l.image.id}
                                width="1320"
                                height="765"
                                alt={l.image.alt_text}
                              />}
                          </div>
                        </div>
                      }
                    </article>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      )
    })
  }
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/gridWithImageBlock.tsx